import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import "../Css/Settings.css";
import { BiSupport } from "react-icons/bi";
import { TbDeviceMobileCheck } from "react-icons/tb";
import { TextField, Button, Grid, Box } from "@mui/material";
import { toast } from "react-toastify";
import { Typography, CircularProgress } from "@mui/material";
import { MdBorderColor } from "react-icons/md";
import { FaUpload } from "react-icons/fa6";
import Logger from "./Logger";
import { format } from "date-fns";
import { FaListUl } from "react-icons/fa";
import { LiaWhatsapp, LiaFileInvoiceSolid, LiaBoxSolid } from "react-icons/lia";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, } from "recharts";
import { getLoggerBaseURL } from "../utils/getLoggerBaseURL";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Select, MenuItem } from "@mui/material";
import { usePlan } from "../context/PlanContext";

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 6 }, (_, i) => currentYear - i); // e.g., [2025, 2024, ..., 2020]

// Initialize Logger
const logger = new Logger(getLoggerBaseURL());

function isStarterPlan(plan) {
  if (!plan) return false;
  const name = String(plan.planName || "").toLowerCase();
  return name === "starter" || String(plan.charges) === "0";
}

const Settings = () => {
  const { plan, billing, openUpgradeModal, loading: planLoading } = usePlan();
  const userEmail = sessionStorage.getItem("userEmail");
  const [assign, setAssign] = useState(null);
  const [weight, setWeight] = useState(null);
  const [permission, setPermission] = useState(null);
  const [userData, setUserData] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [pickaddress, setPickaddress] = useState("");
  const [margCompanyCode, setMargCompanyCode] = useState("");
  const [margKey, setMargKey] = useState("");
  const [margCompanyId, setMargCompanyId] = useState("");
  const [margDecryptKey, setMargDecryptKey] = useState("");
  const permis = sessionStorage.getItem("permissions");
  const [columnMappings, setColumnMappings] = useState({
    orderNo: "",
    companyName: "",
    amount: "",
    date: "",
    Summary: "",
    salesman: "",
    route: "",
    missedRow: "",
  });

  const [dispatchers, setDispatchers] = useState([]);
  const [pickupTime, setPickupTime] = useState("");
  const [pickupDate, setPickupDate] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [whatsAppMessages, setWhatsAppMessages] = useState("");
  const [whatsAppUsage, setWhatsAppUsage] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [syncing, setSyncing] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRange, setSelectedRange] = useState("today");
  const [apiIntegrationEnabled, setApiIntegrationEnabled] = useState(false);
  const storedRole = sessionStorage.getItem("role");
  const isDispatcher = storedRole === "dispatcher";
  let sessionPermission = {};
  const permissionString = sessionStorage.getItem("permissions");
  if (permissionString) {
    sessionPermission = JSON.parse(permissionString);
  } else {
    logger.log("Permission missing", "ERROR");
  }
  const [activeSection, setActiveSection] = useState(() => {
    if (isDispatcher) {
      return sessionPermission.orderCreation
        ? "AssignSettings"
        : "UploadSettings";
    } else {
      return "BusinessSettings";
    }
  });

  const handleColumnChange = (field, value) => {
    setColumnMappings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApiIntegrationToggle = (checked) => {
    if (checked) {
      toast.info("API integration is not available on the Starter plan. Upgrade to Advance to enable it.");
      openUpgradeModal({
        code: "FEATURE_LOCKED",
        message:
          "API integration is not included in the Starter plan. Upgrade to Advance to enable this feature.",
        upgrade: billing?.upgrade,
      });
      return;
    }
    setApiIntegrationEnabled(false);
  };

  useEffect(() => {
    fetchDispatchers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDispatchers = async () => {
    const adminEmail = sessionStorage.getItem("userEmail");
    try {
      const response = await fetch(`/api/dispatcher/getAll/${adminEmail}`);
      const data = await response.json();
      setDispatchers(data);
    } catch (error) {
      logger.log(`Error fetching dispatchers: ${error.message}`, "ERROR");
    }
  };

  useEffect(() => {
    const fetchColumnMappings = async () => {
      try {
        const response = await fetch(`/api/excelColumns/${userEmail}`);
        const data = await response.json();
        const savedMappings = data.columnMappings || [];

        // Convert savedMappings into a format for the state (keep defaults for new fields)
        const newColumnMappings = savedMappings.reduce((acc, mapping) => {
          acc[mapping.fieldName] = mapping.excelColumn;
          return acc;
        }, {});

        setColumnMappings((prev) => ({
          ...prev,
          ...newColumnMappings,
        }));
      } catch (error) {
        logger.log(`Error fetching column mappings: ${error.message}`, "ERROR");
      }
    };

    fetchColumnMappings();
  }, [userEmail]);

  const handleUploadSettingsSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/api/saveColumnMappings/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(columnMappings),
      });

      if (response.ok) {
        alert("Upload Settings updated successfully");
        toast.success("Upload Settings updated successfully");
      } else {
        toast.error("Failed to update Upload Settings");
      }
    } catch (error) {
      toast.error("Error updating Upload Settings");
      logger.log(`Error saving column mappings: ${error.message}`, "ERROR");
    }
  };

  const handleTogglePick = async (permissionName, newValue) => {
    try {
      setPermission((prevPermissions) => ({
        ...prevPermissions,
        [permissionName]: newValue,
      }));

      const response = await fetch(`/api/updatePickup/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ permissionName, value: newValue }),
      });

      if (response.ok) {
        await response.json();
        if (permis) {
          const permissions = JSON.parse(permis);

          // Step 3: Update the `setPickup` value
          permissions.setPickup = newValue;

          // Step 4: Store the updated object back to sessionStorage
          sessionStorage.setItem("permissions", JSON.stringify(permissions));
        }
      } else {
        logger.log("Failed to update permission", "ERROR");
      }
    } catch (error) {
      logger.log(`Error updating permission: ${error.message}`, "ERROR");
    }
  };

  const handleToggleAssignByArea = async (permissionName, newValue) => {
    try {
      // Call API to update "Assign Based on Area"
      setAssign(newValue);

      const response = await fetch(`/api/update-auto-assign/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          permissionName,
          value: newValue, // Update only the "Assign Based on Area" value(True/False)
        }),
      });

      if (response.ok) {
        await response.json();
      } else {
        logger.log("Failed to update based on Area", "ERROR");
      }
    } catch (error) {
      logger.log(`Error updating based on Area: ${error.message}`, "ERROR");
    }
  };

  const handleToggleAssignByWeight = async (permissionName, newValue) => {
    try {
      // Call API to update "Assign Based on Weight"
      setWeight(newValue);
      const response = await fetch(`/api/update-auto-assign/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          permissionName,
          value: newValue, // Update only the "Assign Based on Weight" value
        }),
      });

      if (response.ok) {
        await response.json();
      } else {
        logger.log("Failed to update based on Weight", "ERROR");
      }
    } catch (error) {
      logger.log(`Error updating based on Weight: ${error.message}`, "ERROR");
    }
  };

  const handleToggle = async (dispatcherId, permissionName, newValue) => {
    try {
      setDispatchers((prevDispatchers) =>
        prevDispatchers.map((dispatcher) =>
          dispatcher.email === dispatcherId
            ? {
              ...dispatcher,
              permissions: {
                ...dispatcher.permissions,
                [permissionName]: newValue,
              },
            }
            : dispatcher
        )
      );

      const response = await fetch(
        `/api/dispatcher/updatePermission/${userEmail}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            dispatcherId,
            permissionName,
            value: newValue,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        let P = data.permissions;
        // Step 1: Check if P is already an object
        if (typeof P === "object" && P !== null) {
          // Step 2: Update the `setPickup` value in the object
          P.setPickup = newValue;

          // Step 3: Store the updated object back to sessionStorage
          sessionStorage.setItem("permissions", JSON.stringify(P));
        } else {
          logger.log(`Unexpected data format for permissions: ${P}`, "ERROR");
        }
      } else {
        logger.log("Failed to update permission", "ERROR");
      }
    } catch (error) {
      logger.log(`Error updating permission: ${error.message}`, "ERROR");
    }
  };

  const handleWhatsAppToggle = async (statusName, newValue) => {
    try {
      // Update the state immediately for a smoother UI experience
      setWhatsAppMessages((prevMessages) => ({
        ...prevMessages,
        [statusName]: newValue,
      }));

      // Send the update request to the API
      const response = await fetch(`/api/updateWhatsAppStatus/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ statusName, value: newValue }),
      });

      if (response.ok) {
        const data = await response.json();

        // Update session storage with the new WhatsApp statuses
        sessionStorage.setItem(
          "whatsappStatuses",
          JSON.stringify(data.whatsappStatuses)
        );
      } else {
        logger.log("Failed to update WhatsApp status", "ERROR");
      }
    } catch (error) {
      logger.log(`Error updating WhatsApp status: ${error.message}`, "ERROR");
    }
  };

  const handleDropdownChange = async (permissionName, newValue) => {
    try {
      setPermission((prevPermissions) => ({
        ...prevPermissions,
        [permissionName]: newValue,
      }));

      const response = await fetch(
        `/api/dispatcher/updateSpecialPermission/${userEmail}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ permissionName, value: newValue }),
        }
      );

      if (response.ok) {
        await response.json();
      } else {
        logger.log("Failed to update permission", "ERROR");
      }
    } catch (error) {
      logger.log(`Error updating permission: ${error.message}`, "ERROR");
    }
  };

  const handleUrgentDeliveryChange = async (e) => {
    const [value, unit] = e.target.value.split("|");
    try {
      setPermission((prevPermissions) => ({
        ...prevPermissions,
        urgentDeliveryValue: Number(value),
        urgentDeliveryUnit: unit,
      }));

      const valueResponse = await fetch(
        `/api/dispatcher/updateSpecialPermission/${userEmail}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            permissionName: "urgentDeliveryValue",
            value: Number(value),
          }),
        }
      );

      const unitResponse = await fetch(
        `/api/dispatcher/updateSpecialPermission/${userEmail}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            permissionName: "urgentDeliveryUnit",
            value: unit,
          }),
        }
      );

      if (!valueResponse.ok || !unitResponse.ok) {
        logger.log("Failed to update urgent delivery settings", "ERROR");
      }
    } catch (error) {
      logger.log(
        `Error updating urgent delivery settings: ${error.message}`,
        "ERROR"
      );
    }
  };

  useEffect(() => {
    const fetchUsage = async () => {
      try {
        // const response = await fetch(`${process.env.REACT_APP_API_URL}/api/whatsappUsage/${userEmail}?year=${selectedYear}`, {
        const response = await fetch(
          `/api/whatsappUsage/${userEmail}?year=${selectedYear}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch usage data");
        }

        const data = await response.json();
        setWhatsAppUsage(data.whatsappUsage || []);
      } catch (err) {
        logger.log(`Error fetching WhatsApp usage: ${err.message}`, "ERROR");
      }
    };

    fetchUsage();
  }, [selectedYear, userEmail]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`/api/getUsersEmailSettings/${userEmail}`);
        if (response.ok) {
          const data = await response.json();
          const permission = data.user.permissions;
          const assign = data.user.autoAssignBasedOnArea;
          const weight = data.user.autoAssignBasedOnWeight;
          setWhatsAppMessages(data.user.whatsappStatuses);

          setAssign(assign);
          setWeight(weight);
          setPermission(permission);
          setUserData(data.user);
          if (data.user.pickup && data.user.pickup.length > 0) {
            setCompanyName(data.user.pickup[0].comName);
            setPhoneNo(data.user.pickup[0].comPhone);
            setPickaddress(data.user.pickup[0].comAddress);
            setPickupTime(data.user.pickup[0].pickTime);
            setPickupDate(data.user.pickup[0].pickDate);
            setDeliveryTime(data.user.pickup[0].delTime);
            setDeliveryDate(data.user.pickup[0].delDate);
          }
          if (whatsAppMessages) {
          }
          if (data.user.margData && data.user.margData.length > 0) {
            setMargCompanyCode(data.user.margData[0].margCompanyCode);
            setMargKey(data.user.margData[0].margKey);
            setMargCompanyId(data.user.margData[0].margCompanyId);
            setMargDecryptKey(data.user.margData[0].margDecryptKey);
          }
        } else {
          logger.log("Failed to fetch user data on Settings page", "ERROR");
        }
      } catch (error) {
        logger.log(`Error fetching user data: ${error.message}`, "ERROR");
      }
    };

    if (userEmail) {
      fetchUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmail]);

  if (!userData) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
        }}
      >
        <CircularProgress />
        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Fetching Data...
        </Typography>
      </div>
    ); // Display a loading message while data is being fetched
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Save updated values in session storage
    sessionStorage.setItem("companyName", companyName);
    sessionStorage.setItem("phoneNo", phoneNo);
    sessionStorage.setItem("address", address);
    sessionStorage.setItem("margCompanyCode", margCompanyCode);
    sessionStorage.setItem("margKey", margKey);
    sessionStorage.setItem("margCompanyId", margCompanyId);
    sessionStorage.setItem("margDecryptKey", margDecryptKey);

    // Make API call to save the updated data to the database
    const updatedData = {
      companyName,
      phoneNo,
      address,
      margCompanyCode,
      margKey,
      margCompanyId,
      margDecryptKey,
    };

    try {
      const response = await fetch(`/api/updatePickup/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });

      if (response.ok) {
        alert("Data updated successfully");
        toast.success("Data updated successfully");
      } else {
        toast.error("Failed to update data");
        logger.log("Failed to save data", "ERROR");
      }
    } catch (error) {
      toast.error("Error updating data");
      logger.log(`Error saving data: ${error.message}`, "ERROR");
    }
  };

  const handleFormSubmitDate = async (e) => {
    e.preventDefault();

    const formData = {
      Pick_Time: pickupTime,
      Pick_Date: pickupDate,
      Del_Time: deliveryTime,
      Del_Date: deliveryDate,
    };

    sessionStorage.setItem("pickTime", pickupTime);
    sessionStorage.setItem("pickDate", pickupDate);
    sessionStorage.setItem("delDate", deliveryDate);
    sessionStorage.setItem("delTime", deliveryTime);

    try {
      const response = await fetch(`/api/updatePickup/${userEmail}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert("Data updated successfully");
        toast.success("Data updated successfully");
      } else {
        toast.error("Failed to update data");
        logger.log("Failed to save data", "ERROR");
      }
    } catch (error) {
      toast.error("Error updating data");
      logger.log(`Error saving data: ${error.message}`, "ERROR");
    }
  };

  const fetchMargOrders = async (range) => {
    const adminEmail = sessionStorage.getItem("userEmail");
    if (!adminEmail) return;

    setSyncing(true);
    try {
      const res = await fetch(`/api/marg/syncMargOrders/${adminEmail}/${selectedRange}`, {
        method: "POST",
      });
      const data = await res.json();

      setSnackbar({
        open: true,
        message: `Sync completed. ${data.inserted} orders inserted.`,
        severity: "success",
      });
    } catch (err) {
      setSnackbar({
        open: true,
        message: `Sync failed. Check logs. ${err.message || "Unknown error"}`,
        severity: "error",
      });
    } finally {
      setSyncing(false);
    }
  };

  const { organization, address, gst } = userData;

  const formattedUsage = whatsAppUsage.map((entry) => {
    const [year, month] = entry.month.split("-");
    const date = new Date(`${year}-${month}-01`);
    return {
      ...entry,
      label: date.toLocaleString("default", {
        month: "short",
        year: "numeric",
      }),
    };
  });

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const count = payload[0].value;
      const bill = (
        count * Number(process.env.REACT_APP_WHATSAPP_CHARGES_PER_MESSAGE)
      ).toFixed(2);
      return (
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "12px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
            border: "1px solid #e5e7eb",
            fontSize: "14px",
            color: "#111827",
            textAlign: "center",
          }}
        >
          <p
            style={{ fontWeight: "600", marginBottom: "4px", color: "#07a6ef" }}
          >
            {label}
          </p>
          <p style={{ margin: "2px 0" }}>Messages: {count}</p>
          <p style={{ margin: "2px 0" }}>Bill: ₹{bill}</p>
        </div>
      );
    }
    return null;
  };

  const renderSection = () => {
    switch (activeSection) {
      case "BusinessSettings":
        return (
          <div className="settings-panel">
            <div className="settings-page-header">
              <h2 className="settingsH2">Business Settings</h2>
              <p className="settings-page-subtitle">
                View your business profile, delivery thresholds, and urgent order timing.
              </p>
            </div>

            <div className="settings-card">
              <h3 className="settings-card-title">Business details</h3>
              <p className="settings-card-desc">Registered company information for your organization.</p>
              <div className="settings-info-grid">
                <div className="settings-info-item">
                  <span className="settings-info-label">Business Name</span>
                  <span className="settings-info-value">{organization}</span>
                </div>
                <div className="settings-info-item">
                  <span className="settings-info-label">Business Address</span>
                  <span className="settings-info-value">{address}</span>
                </div>
                <div className="settings-info-item">
                  <span className="settings-info-label">GSTIN Number</span>
                  <span className="settings-info-value">{gst}</span>
                </div>
              </div>
            </div>

            <div className="settings-card">
              <h3 className="settings-card-title">Admin details</h3>
              <p className="settings-card-desc">Primary administrator contact for this account.</p>
              <div className="settings-info-grid">
                <div className="settings-info-item">
                  <span className="settings-info-label">Admin Name</span>
                  <span className="settings-info-value">{userData.name}</span>
                </div>
                <div className="settings-info-item">
                  <span className="settings-info-label">Admin Email</span>
                  <span className="settings-info-value">{userEmail}</span>
                </div>
                <div className="settings-info-item">
                  <span className="settings-info-label">Phone No.</span>
                  <span className="settings-info-value">{userData.phone}</span>
                </div>
              </div>
            </div>

            <div className="settings-card">
              <h3 className="settings-card-title">Delivery & display preferences</h3>
              <p className="settings-card-desc">
                Configure delay highlighting, data visibility, working hours, and urgent delivery windows.
              </p>
              <div className="dropdown-container">
                <div className="settingg">
                  <label>
                    Slight delay threshold (highlighted in blue)
                  </label>
                  <select
                    value={permission?.hour1}
                    onChange={(e) =>
                      handleDropdownChange("hour1", e.target.value)
                    }
                  >
                    <option value="6">6 hr</option>
                    <option value="12">12 hr</option>
                    <option value="24">24 hr</option>
                  </select>
                </div>
                <div className="settingg">
                  <label>
                    Late delivery threshold (highlighted in red)
                  </label>
                  <select
                    value={permission?.hour2}
                    onChange={(e) =>
                      handleDropdownChange("hour2", e.target.value)
                    }
                  >
                    <option value="6">6 hr</option>
                    <option value="12">12 hr</option>
                    <option value="24">24 hr</option>
                  </select>
                </div>
                <div className="settingg">
                  <label>Data visibility period</label>
                  <select
                    value={permission.dataDuration}
                    onChange={(e) =>
                      handleDropdownChange("dataDuration", e.target.value)
                    }
                  >
                    <option value="1">This month</option>
                    <option value="2">Past 2 months</option>
                    <option value="6">Past 6 months</option>
                    <option value="12">Past 1 year</option>
                    <option value="100">All data</option>
                  </select>
                </div>
                <div className="settingg">
                  <label>
                    Urgent order delivery time (within working hours)
                  </label>
                  <select
                    value={`${permission?.urgentDeliveryValue || 2}|${permission?.urgentDeliveryUnit || "hours"}`}
                    onChange={handleUrgentDeliveryChange}
                  >
                    <option value="30|minutes">30 minutes</option>
                    <option value="1|hours">1 hour</option>
                    <option value="2|hours">2 hours</option>
                    <option value="4|hours">4 hours</option>
                    <option value="6|hours">6 hours</option>
                    <option value="12|hours">12 hours</option>
                    <option value="1|business_days">1 business day</option>
                    <option value="2|business_days">2 business days</option>
                    <option value="3|business_days">3 business days</option>
                  </select>
                </div>
                <div className="settingg">
                  <label>Working hours start</label>
                  <input
                    type="time"
                    className="settings-input"
                    value={permission?.workStartTime || "09:00"}
                    onChange={(e) =>
                      handleDropdownChange("workStartTime", e.target.value)
                    }
                  />
                </div>
                <div className="settingg">
                  <label>Working hours end</label>
                  <input
                    type="time"
                    className="settings-input"
                    value={permission?.workEndTime || "18:00"}
                    onChange={(e) =>
                      handleDropdownChange("workEndTime", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case "DispatcherSettings":
        return (
          <div className="dispatcher-settings">
            <div className="settings-page-header">
              <h2 className="settingsH2">Dispatcher Settings</h2>
              <p className="settings-page-subtitle">
                Manage permissions for each dispatcher in your organization.
              </p>
            </div>
            {dispatchers && dispatchers.length > 0 ? (
              dispatchers.map((dispatcher) => (
                <div key={dispatcher._id} className="dispatcher-section">
                  <h3>{dispatcher.name}</h3>
                  <div className="toggle-group">
                    <div className="toggle-row">
                      <label>Uploading Order</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.billUpload}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "billUpload",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Assign Orders to Drivers</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.canAssign}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "canAssign",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Complete Order</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.completeBill}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "completeBill",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Reassign Order</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.reassignBill}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "reassignBill",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Edit Orders</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.editBill}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "editBill",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Location Tracking By Dispatcher</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.locationTracking}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "locationTracking",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Assigning Orders in Bulk</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.assignBulk}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "assignBulk",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Order Creation Settings</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.orderCreation}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "orderCreation",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                    <div className="toggle-row">
                      <label>Order Upload Settings</label>
                      <ToggleSwitch
                        checked={dispatcher.permissions.orderUpload}
                        onChange={(e) =>
                          handleToggle(
                            dispatcher.email,
                            "orderUpload",
                            e.target.checked
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="settings-empty-state">
                <div className="settings-empty-icon">
                  <FaListUl />
                </div>
                <span>No dispatcher created yet</span>
              </div>
            )}
          </div>
        );
      case "AssignSettings":
        return (
          <div className="order-creation-settings">
            <div className="settings-page-header">
              <h2 className="settingsH2">Order Creation Settings</h2>
              <p className="settings-page-subtitle">
                Configure auto-assignment, default pickup details, and requested delivery times.
              </p>
            </div>
            <div>
              <div className="settings-card">
                <h3 className="settings-card-title">Auto assign functionality</h3>
                <p className="settings-card-desc">
                  Automatically assign drivers based on area or weight.
                </p>
                <Box
                  className="settings-form-wrap"
                  component="form"
                  sx={{
                    padding: "0",
                    borderRadius: "0",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    margin: "0",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <div className="toggle-roww">
                        <label className="Pickup">
                          Assign Driver Based on Area:
                        </label>

                        <ToggleSwitch
                          checked={assign}
                          onChange={(e) =>
                            handleToggleAssignByArea(
                              "assignByArea",
                              e.target.checked
                            )
                          }
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className="toggle-roww">
                        <label className="Pickup">
                          Assign Driver Based on Weight:
                        </label>
                        <ToggleSwitch
                          checked={weight}
                          onChange={(e) =>
                            handleToggleAssignByWeight(
                              "assignByWeight",
                              e.target.checked
                            )
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </div>
            <div>
              <div className="settings-card">
                <div className="toggle-row" style={{ marginBottom: 16, paddingTop: 0 }}>
                  <label className="Pickupp">
                    Set these details as default pickup address
                  </label>
                  <ToggleSwitch
                    checked={permission?.setPickup}
                    onChange={(e) =>
                      handleTogglePick("setPickup", e.target.checked)
                    }
                  />
                </div>
                <Box
                  className="settings-form-wrap"
                  component="form"
                  onSubmit={handleFormSubmit}
                  sx={{
                    padding: "0",
                    borderRadius: "0",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    margin: "0",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Company Name"
                        variant="outlined"
                        fullWidth
                        required
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Phone No."
                        variant="outlined"
                        fullWidth
                        required
                        value={phoneNo}
                        onChange={(e) => setPhoneNo(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Address"
                        variant="outlined"
                        fullWidth
                        required
                        value={pickaddress}
                        onChange={(e) => setPickaddress(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} textAlign="center" className="settings-save-row">
                    <Button type="submit" variant="contained" color="primary">
                      Save
                    </Button>
                  </Grid>
                </Box>
              </div>
            </div>
            <div>
              <div className="settings-card">
                <h3 className="settings-card-title">Requested date and time</h3>
                <p className="settings-card-desc">
                  Default pickup and delivery schedule for new orders.
                </p>
                <Box
                  className="settings-form-wrap"
                  component="form"
                  onSubmit={handleFormSubmitDate}
                  sx={{
                    padding: "0",
                    borderRadius: "0",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    margin: "0",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Requested Pickup Time (optional)"
                        variant="outlined"
                        fullWidth
                        type="time"
                        value={
                          pickupTime
                            ? (() => {
                              const [time, modifier] = pickupTime.split(" ");
                              let [hours, minutes] = time.split(":");

                              if (hours === "12") {
                                hours = "00";
                              }

                              if (modifier === "PM") {
                                hours = parseInt(hours, 10) + 12;
                              }

                              return `${hours
                                .toString()
                                .padStart(2, "0")}:${minutes}`;
                            })()
                            : ""
                        }
                        onChange={(e) => setPickupTime(e.target.value)}
                        InputLabelProps={{
                          shrink: true, // Forces the label to shrink to the top position when the input is focused or has a value
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Requested Pickup Date (optional)"
                        variant="outlined"
                        fullWidth
                        type="date"
                        value={
                          pickupDate
                            ? format(new Date(pickupDate), "yyyy-MM-dd")
                            : ""
                        }
                        onChange={(e) => setPickupDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true, // Forces the label to shrink to the top position when the input is focused or has a value
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Requested Delivery Date (optional)"
                        variant="outlined"
                        fullWidth
                        type="date"
                        value={
                          deliveryDate
                            ? format(new Date(deliveryDate), "yyyy-MM-dd")
                            : ""
                        }
                        onChange={(e) => setDeliveryDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true, // Forces the label to shrink to the top position when the input is focused or has a value
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Requested Delivery Time (optional)"
                        variant="outlined"
                        fullWidth
                        type="time"
                        value={
                          deliveryTime
                            ? (() => {
                              const [time, modifier] = deliveryTime.split(" ");
                              let [hours, minutes] = time.split(":");

                              if (hours === "12") {
                                hours = "00";
                              }

                              if (modifier === "PM") {
                                hours = parseInt(hours, 10) + 12;
                              }

                              return `${hours
                                .toString()
                                .padStart(2, "0")}:${minutes}`;
                            })()
                            : ""
                        }
                        onChange={(e) => setDeliveryTime(e.target.value)}
                        InputLabelProps={{
                          shrink: true, // Forces the label to shrink to the top position when the input is focused or has a value
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} textAlign="center" className="settings-save-row">
                    <Button type="submit" variant="contained" color="primary">
                      Save
                    </Button>
                  </Grid>
                </Box>
              </div>
            </div>
            <div>
              {planLoading ? (
                <div className="settings-card">
                  <Typography variant="body2" color="text.secondary">
                    Loading integration settings…
                  </Typography>
                </div>
              ) : isStarterPlan(plan) ? (
                <div className="settings-card">
                  <h3 className="settings-card-title">API integration</h3>
                  <p className="settings-card-desc">
                    Connect external systems via API to create orders automatically.
                  </p>
                  <div className="toggle-row" style={{ paddingTop: 0 }}>
                    <label className="Pickupp">Enable API integration</label>
                    <ToggleSwitch
                      checked={apiIntegrationEnabled}
                      onChange={(e) => handleApiIntegrationToggle(e.target.checked)}
                    />
                  </div>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    API integration is disabled on the Starter plan. Upgrade to Advance to turn it on.
                  </Typography>
                </div>
              ) : (
                <div className="settings-card">
                  <h3 className="settings-card-title">Marg integration</h3>
                  <p className="settings-card-desc">
                    Fetch orders from Marg using your API credentials.
                  </p>
                  <Box
                    className="settings-form-wrap"
                    component="form"
                    onSubmit={handleFormSubmit}
                    sx={{
                      padding: "0",
                      borderRadius: "0",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      margin: "0",
                    }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          label="Company Code from Marg"
                          variant="outlined"
                          fullWidth
                          required
                          value={margCompanyCode}
                          onChange={(e) => setMargCompanyCode(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Key from Marg"
                          variant="outlined"
                          fullWidth
                          required
                          value={margKey}
                          onChange={(e) => setMargKey(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Company ID from Marg"
                          variant="outlined"
                          fullWidth
                          required
                          value={margCompanyId}
                          onChange={(e) => setMargCompanyId(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Decryption Key from Marg"
                          variant="outlined"
                          fullWidth
                          required
                          value={margDecryptKey}
                          onChange={(e) => setMargDecryptKey(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} textAlign="center" className="settings-save-row">
                      <Button type="submit" variant="contained" color="primary">
                        Save
                      </Button>
                    </Grid>
                  </Box>
                  <div className="settings-save-row">
                    <Button
                      variant="contained"
                      disabled={syncing}
                      onClick={() => setOpenDialog(true)}
                      sx={{
                        backgroundColor: "#07a6ef",
                        "&:hover": {
                          backgroundColor: syncing ? "#07a6ef" : "primary.main",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#07a6ef",
                          opacity: 0.6,
                          color: "#fff",
                        },
                      }}
                    >
                      🔄 {syncing ? "Syncing..." : "Sync Marg Orders"}
                    </Button>
                  </div>
                  <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      severity={snackbar.severity}
                      variant="filled"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        boxShadow: 6,
                        borderLeft: "6px solid",
                        borderColor:
                          snackbar.severity === "success"
                            ? "success.dark"
                            : snackbar.severity === "error"
                              ? "error.dark"
                              : "warning.dark",
                      }}
                    >
                      {snackbar.message}
                    </Alert>
                  </Snackbar>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    After completion, go to{" "}
                    <Link href="/CurrentOrder">Orders</Link> to see updated data.
                  </Typography>
                  <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                    <DialogTitle>Select Sync Range</DialogTitle>

                    <DialogContent>
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <Select
                          value={selectedRange}
                          onChange={(e) => setSelectedRange(e.target.value)}
                        >
                          <MenuItem value="today">Today</MenuItem>
                          <MenuItem value="2days">Last 2 Days</MenuItem>
                          <MenuItem value="3days">Last 3 Days</MenuItem>
                        </Select>
                      </FormControl>
                    </DialogContent>

                    <DialogActions>
                      <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setOpenDialog(false);
                          fetchMargOrders(selectedRange);
                        }}
                      >
                        Sync
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              )}
            </div>
          </div>
        );
      case "UploadSettings":
        return (
          <div className="settings-panel">
            <div className="settings-page-header">
              <h2 className="settingsH2">Order Upload Settings</h2>
              <p className="settings-page-subtitle">
                Map Excel column letters to order fields for ERP uploads.
              </p>
            </div>
            <div className="settings-card">
              <Box
                className="settings-form-wrap"
                component="form"
                onSubmit={handleUploadSettingsSubmit}
                sx={{
                  padding: "0",
                  borderRadius: "0",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  margin: "0",
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      label="Order No. Column"
                      placeholder="e.g., A"
                      helperText="Enter the Excel column letter for Order No."
                      variant="outlined"
                      fullWidth
                      required
                      value={columnMappings.orderNo || ""}
                      onChange={(e) =>
                        handleColumnChange("orderNo", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Company Name Column"
                      variant="outlined"
                      placeholder="e.g., B"
                      helperText="Enter the Excel column letter for Company Name"
                      fullWidth
                      required
                      value={columnMappings.companyName || ""}
                      onChange={(e) =>
                        handleColumnChange("companyName", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Amount Column"
                      variant="outlined"
                      placeholder="e.g., C"
                      helperText="Enter the Excel column letter for Amount"
                      fullWidth
                      required
                      value={columnMappings.amount || ""}
                      onChange={(e) =>
                        handleColumnChange("amount", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Date Column (Date Format : DD-MM-YYYY)"
                      variant="outlined"
                      placeholder="e.g., D"
                      helperText="Enter the Excel column letter for Date"
                      fullWidth
                      required
                      value={columnMappings.date || ""}
                      onChange={(e) => handleColumnChange("date", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Summary Column"
                      variant="outlined"
                      placeholder="e.g., E"
                      helperText="Enter the Excel column letter for Summary"
                      fullWidth
                      value={columnMappings.Summary || ""}
                      onChange={(e) =>
                        handleColumnChange("Summary", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Salesperson Column"
                      variant="outlined"
                      placeholder="e.g., G"
                      helperText="Enter the Excel column letter for Salesperson"
                      fullWidth
                      required
                      value={columnMappings.salesman || ""}
                      onChange={(e) =>
                        handleColumnChange("salesman", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Route Column"
                      variant="outlined"
                      placeholder="e.g., H"
                      helperText="Enter the Excel column letter for Route"
                      fullWidth
                      required
                      value={columnMappings.route || ""}
                      onChange={(e) =>
                        handleColumnChange("route", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Row No. from which orders are found"
                      variant="outlined"
                      placeholder="e.g., 1"
                      helperText="Enter the Excel row number where order data starts"
                      fullWidth
                      required
                      value={columnMappings.missedRow || ""}
                      onChange={(e) =>
                        handleColumnChange("missedRow", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} textAlign="center" className="settings-save-row">
                    <Button type="submit" variant="contained" color="primary">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </div>
          </div>
        );
      case "WhatsAppSettings":
        return (
          <div className="dispatcher-settings">
            {whatsAppMessages ? (
              <>
                <div className="settings-page-header">
                  <h2 className="settingsH2">
                    WhatsApp Messages Settings
                  </h2>
                  <p className="settings-page-subtitle">
                    Choose which order status updates are sent via WhatsApp.
                  </p>
                </div>
                <h3 className="whatsapp-section-title">
                  Send updates to customer
                  <span className="requiredFields">*</span>
                </h3>
                <div className="whatsapp-messages">
                  <div className="whatsapp-toggle-row">
                    <label>Order is Placed successfully</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.orderPlaced}
                      onChange={(e) =>
                        handleWhatsAppToggle("orderPlaced", e.target.checked)
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is Packed successfully</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.orderPacked}
                      onChange={(e) =>
                        handleWhatsAppToggle("orderPacked", e.target.checked)
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is Picked Up by Driver</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.pickedUp}
                      onChange={(e) =>
                        handleWhatsAppToggle("pickedUp", e.target.checked)
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is On The Way</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.onTheWay}
                      onChange={(e) =>
                        handleWhatsAppToggle("onTheWay", e.target.checked)
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is Delivered (successful / fail)</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.delivered}
                      onChange={(e) =>
                        handleWhatsAppToggle("delivered", e.target.checked)
                      }
                    />
                  </div>
                </div>
                <h3 className="whatsapp-section-title">
                  Send updates to admin
                  <span className="requiredFields">*</span>
                </h3>
                <div className="whatsapp-messages">
                  <div className="whatsapp-toggle-row">
                    <label>Order is Placed successfully</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.orderPlacedAdmin}
                      onChange={(e) =>
                        handleWhatsAppToggle(
                          "orderPlacedAdmin",
                          e.target.checked
                        )
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is Packed successfully</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.orderPackedAdmin}
                      onChange={(e) =>
                        handleWhatsAppToggle(
                          "orderPackedAdmin",
                          e.target.checked
                        )
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is Picked Up by Driver</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.pickedUpAdmin}
                      onChange={(e) =>
                        handleWhatsAppToggle("pickedUpAdmin", e.target.checked)
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is On The Way</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.onTheWayAdmin}
                      onChange={(e) =>
                        handleWhatsAppToggle("onTheWayAdmin", e.target.checked)
                      }
                    />
                  </div>
                  <div className="whatsapp-toggle-row">
                    <label>Order is Delivered (successful / fail)</label>
                    <ToggleSwitch
                      checked={whatsAppMessages.deliveredAdmin}
                      onChange={(e) =>
                        handleWhatsAppToggle("deliveredAdmin", e.target.checked)
                      }
                    />
                  </div>
                </div>
                <p className="whatsapp-settings-note">
                  <span className="requiredFields">*</span> Every WhatsApp message
                  will cost ₹{" "}
                  {process.env.REACT_APP_WHATSAPP_CHARGES_PER_MESSAGE}{" "}
                  (additionally)
                </p>
              </>
            ) : (
              <div className="settings-empty-state">
                <div className="settings-empty-icon">
                  <FaListUl />
                </div>
                <span>WhatsApp settings not available</span>
              </div>
            )}
          </div>
        );
      case "WhatsAppBill":
        return (
          <div className="settings-panel">
            <div className="settings-page-header">
              <h2 className="settingsH2">WhatsApp Message Usage Bill</h2>
              <p className="settings-page-subtitle">
                Monthly breakdown of WhatsApp messages sent and associated charges.
              </p>
            </div>

            <div className="settings-chart-wrap">
              <select
                className="settings-year-select"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>

              <div className="settings-chart-card">
                {formattedUsage.length === 0 ||
                  formattedUsage.every((item) => item.count === 0) ? (
                  <div className="settings-chart-empty">
                    No data found for the selected year
                  </div>
                ) : (
                  <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={formattedUsage}>
                      <CartesianGrid stroke="#e2e8f0" strokeDasharray="4 4" />
                      <XAxis dataKey="label" tick={{ fontSize: 12 }} />
                      <YAxis tick={{ fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#f9fafb",
                          borderRadius: "8px",
                          border: "1px solid #e5e7eb",
                        }}
                        cursor={{ fill: "#e0f2fe" }}
                        content={<CustomTooltip />}
                      />
                      <Bar
                        dataKey="count"
                        fill="#38bdf8"
                        radius={[6, 6, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </div>
            </div>
          </div>
        );
      case "orderNotification":
        return (
          <div className="settings-panel">
            <NotificationSettings />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Navbar />
      <div className="settings-container">
        <div className="settings-sidebar">
          <div className="settings-sidebar-header">
            <h3>Settings</h3>
            <p>Manage your account and preferences</p>
          </div>
          <div className="settings-nav">
            {!isDispatcher && (
              <div
                className={`sidebar-item ${activeSection === "BusinessSettings" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("BusinessSettings")}
              >
                <BiSupport /> <span className="sidebar-item-label">Business Settings</span>
              </div>
            )}

            {!isDispatcher && (
              <div
                className={`sidebar-item ${activeSection === "DispatcherSettings" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("DispatcherSettings")}
              >
                <TbDeviceMobileCheck /> <span className="sidebar-item-label">Dispatcher Settings</span>
              </div>
            )}

            {storedRole === "admin" ||
              (storedRole === "dispatcher" &&
                dispatchers.find((d) => d.email === userEmail)?.permissions
                  .orderCreation) ? (
              <div
                className={`sidebar-item ${activeSection === "AssignSettings" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("AssignSettings")}
              >
                <MdBorderColor /> <span className="sidebar-item-label">Order Creation Settings</span>
              </div>
            ) : null}

            {storedRole === "admin" ||
              (storedRole === "dispatcher" &&
                dispatchers.find((d) => d.email === userEmail)?.permissions
                  .orderUpload) ? (
              <div
                className={`sidebar-item ${activeSection === "UploadSettings" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("UploadSettings")}
              >
                <FaUpload /> <span className="sidebar-item-label">Order Upload Settings</span>
              </div>
            ) : null}

            {!isDispatcher && (
              <div
                className={`sidebar-item ${activeSection === "WhatsAppSettings" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("WhatsAppSettings")}
              >
                <LiaWhatsapp /> <span className="sidebar-item-label">WhatsApp Messages Settings</span>
              </div>
            )}

            {!isDispatcher && (
              <div
                className={`sidebar-item ${activeSection === "WhatsAppBill" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("WhatsAppBill")}
              >
                <LiaFileInvoiceSolid /> <span className="sidebar-item-label">WhatsApp Message Usage Bill</span>
              </div>
            )}

            {!isDispatcher && (
              <div
                className={`sidebar-item ${activeSection === "orderNotification" ? "active" : ""
                  }`}
                onClick={() => setActiveSection("orderNotification")}
              >
                <LiaBoxSolid /> <span className="sidebar-item-label">Order Notification Settings</span>
              </div>
            )}
          </div>
        </div>
        <div className="settings-content">{renderSection()}</div>
      </div>
    </>
  );
};

const ToggleSwitch = ({ checked, onChange }) => (
  <label className="settings-toggle-switch">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      autocomplete="off"
    />
    <span className="settings-toggle-slider"></span>
  </label>
);

function NotificationSettings() {
  const [dailyReminderTime, setDailyReminderTime] = useState("09:00");
  const [preDeliveryReminderHours, setPreDeliveryReminderHours] = useState(1);
  const [exceedDeliveryFreqMinutes, setExceedDeliveryFreqMinutes] = useState(30);
  const [enableDailyReminder, setEnableDailyReminder] = useState(true);
  const [enablePreDeliveryReminder, setEnablePreDeliveryReminder] = useState(true);
  const [enableOverdueReminder, setEnableOverdueReminder] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // ✅ use adminEmail instead of organization (as per backend)
  const adminEmail = sessionStorage.getItem("userEmail");

  // 🔹 Fetch existing settings
  useEffect(() => {
    async function fetchSettings() {
      try {
        setLoading(true);
        const res = await fetch(`/api/order/notification/${adminEmail}`);
        const data = await res.json();

        if (!res.ok) {
          logger.log(`Error fetching settings: ${data.message}`, "ERROR");
          return;
        }

        // Populate values from backend or defaults
        setDailyReminderTime(data.dailyReminderTime || "09:00");
        setPreDeliveryReminderHours(data.preDeliveryReminderHours || 1);
        setExceedDeliveryFreqMinutes(data.exceedDeliveryFreqMinutes || 30);

        setEnableDailyReminder(data.enableDailyReminder ?? true);
        setEnablePreDeliveryReminder(data.enablePreDeliveryReminder ?? true);
        setEnableOverdueReminder(data.enableOverdueReminder ?? true);
      } catch (error) {
        logger.log(`Error loading settings:: ${error}`, "ERROR");
      } finally {
        setLoading(false);
      }
    }

    fetchSettings();
  }, [adminEmail]);

  // 🔹 Save or Update settings
  const handleSave = async () => {
    try {
      setSaving(true);

      const payload = {
        dailyReminderTime,
        preDeliveryReminderHours,
        exceedDeliveryFreqMinutes,
        enableDailyReminder,
        enablePreDeliveryReminder,
        enableOverdueReminder,
      };

      const res = await fetch(`/api/order/notification/${adminEmail}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to save settings");
      }

      alert("✅ Notification settings saved successfully!");
    } catch (err) {
      logger.log(`Save failed: ${err}`, "ERROR");
      alert("❌ Failed to save settings. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="settings-loading">Loading notification settings…</div>;

  return (
    <div className="notification-settings">
      <div className="settings-page-header">
        <h2 className="settingsH2">Order Notification Settings</h2>
        <p className="settings-page-subtitle">
          Configure automated reminders for undelivered and overdue orders.
        </p>
      </div>

      <div className="notification-block">
        <label className="notification-toggle">
          <input
            type="checkbox"
            checked={enableDailyReminder}
            onChange={(e) => setEnableDailyReminder(e.target.checked)}
          />
          <span>Enable daily reminder</span>
        </label>
        {enableDailyReminder && (
          <>
            <label htmlFor="dailyReminderTime" className="notification-field-label">
              Daily reminder time (undelivered orders)
            </label>
            <input
              type="time"
              id="dailyReminderTime"
              value={dailyReminderTime}
              onChange={(e) => setDailyReminderTime(e.target.value)}
              className="notification-field-input"
            />
          </>
        )}
      </div>

      <div className="notification-block">
        <label className="notification-toggle">
          <input
            type="checkbox"
            checked={enablePreDeliveryReminder}
            onChange={(e) => setEnablePreDeliveryReminder(e.target.checked)}
          />
          <span>Enable pre-delivery reminder</span>
        </label>
        {enablePreDeliveryReminder && (
          <>
            <label htmlFor="preDeliveryReminderHours" className="notification-field-label">
              Reminder before delivery (hours)
            </label>
            <input
              type="number"
              id="preDeliveryReminderHours"
              min={1}
              max={24}
              value={preDeliveryReminderHours}
              onChange={(e) =>
                setPreDeliveryReminderHours(Number(e.target.value))
              }
              className="notification-field-input"
            />
          </>
        )}
      </div>

      <div className="notification-block">
        <label className="notification-toggle">
          <input
            type="checkbox"
            checked={enableOverdueReminder}
            onChange={(e) => setEnableOverdueReminder(e.target.checked)}
          />
          <span>Enable overdue delivery reminder</span>
        </label>
        {enableOverdueReminder && (
          <>
            <label htmlFor="exceedDeliveryFreqMinutes" className="notification-field-label">
              Exceeded delivery reminder frequency (minutes)
            </label>
            <input
              type="number"
              id="exceedDeliveryFreqMinutes"
              min={5}
              max={180}
              value={exceedDeliveryFreqMinutes}
              onChange={(e) =>
                setExceedDeliveryFreqMinutes(Number(e.target.value))
              }
              className="notification-field-input"
            />
          </>
        )}
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="settings-save-btn"
      >
        {saving ? "Saving…" : "Save Settings"}
      </button>
    </div>
  );
}

export default Settings;